module.exports = __webpack_public_path__ + "media/assets/images/share-overlay-logo-87fbe8b59ff3b332e72e6eb012e95f3f.png";